import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.INVENTORIES,
  nodeType: Generator.NODETYPE.POST2PHASES
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/inventories/post.js